module.exports = __webpack_public_path__ + "static/media/GoSeoBanner1.779d8f70.png";